var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1804_363",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5H4C3.72667 8.5 3.5 8.27333 3.5 8C3.5 7.72667 3.72667 7.5 4 7.5H12C12.2733 7.5 12.5 7.72667 12.5 8C12.5 8.27333 12.2733 8.5 12 8.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5H4C3.72667 8.5 3.5 8.27333 3.5 8C3.5 7.72667 3.72667 7.5 4 7.5H12C12.2733 7.5 12.5 7.72667 12.5 8C12.5 8.27333 12.2733 8.5 12 8.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5V7.5H4V8.5V9.5H12V8.5ZM4 8.5V7.5C4.27895 7.5 4.5 7.72105 4.5 8H3.5H2.5C2.5 8.82562 3.17438 9.5 4 9.5V8.5ZM3.5 8H4.5C4.5 8.27895 4.27895 8.5 4 8.5V7.5V6.5C3.17438 6.5 2.5 7.17438 2.5 8H3.5ZM4 7.5V8.5H12V7.5V6.5H4V7.5ZM12 7.5V8.5C11.721 8.5 11.5 8.27895 11.5 8H12.5H13.5C13.5 7.17438 12.8256 6.5 12 6.5V7.5ZM12.5 8H11.5C11.5 7.72105 11.721 7.5 12 7.5V8.5V9.5C12.8256 9.5 13.5 8.82562 13.5 8H12.5Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1804_363)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.0da27d27a500bc4e6c6c749b95ec88a7.svg";
export { ForwardRef as ReactComponent };